export default "__VITE_ASSET__DeRbjB7L__"